import { Button, Checkbox, CheckboxOnChangeData } from "@fluentui/react-components";
import React, { useCallback, useState } from "react";

import { M365PulseText } from "Shared/Components";
import { SearchBoxPopoverProps } from "./SearchBoxPopover.types";
import { observer } from "mobx-react";
import { useStyles } from "./SearchBoxPopover.styles";

const SearchBoxPopoverBase = ({ popoverContent, closePopoverCallback }: SearchBoxPopoverProps) => {
    const classNames = useStyles();
    const [isShownAgain, updateIsShownAgain] = useState(true);
    const onChecked = useCallback(
        (ev: React.ChangeEvent<HTMLInputElement>, data: CheckboxOnChangeData) => {
            ev.stopPropagation();
            if (data.checked) {
                updateIsShownAgain(false);
            }
        },
        [updateIsShownAgain]
    );
    const onClose = useCallback(() => {
        if (!isShownAgain && popoverContent.dontShowAgainCallback) {
            popoverContent.dontShowAgainCallback();
        }
        closePopoverCallback();
    }, [closePopoverCallback, isShownAgain, popoverContent]);
    return (
        <div className={classNames.root}>
            <M365PulseText weight="semibold" size={400}>
                {popoverContent.title}
            </M365PulseText>
            <M365PulseText className={classNames.message}>{popoverContent.message}</M365PulseText>
            <div className={classNames.selectionRow}>
                <Checkbox onChange={onChecked} label="Don't show again" />
                <Button onClick={onClose} className={classNames.button}>
                    Got it
                </Button>
            </div>
        </div>
    );
};
export const SearchBoxPopover = observer(SearchBoxPopoverBase);
